import { createAction } from '../../../core/helpers'

import { FETCH_BRAND_CURATION_TASK } from '../action-types'

export const cleanupFetchBrandCurationTask = createAction(
  FETCH_BRAND_CURATION_TASK.CLEANUP,
)
